import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { HotkeysSuppressor } from "../hotkeys/HotkeysSuppressor";
import DialogDefaultAction from "./DialogDefaultAction";

interface WarningDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue?: () => void; // Pass the reason to onContinue callback
  title: string;
  content: any;
  isConfirmSave?: boolean;
  typeToProceed?: string[];
  loading?: boolean;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  onClose,
  onContinue,
  title,
  content,
  isConfirmSave = false,
  typeToProceed,
  loading,
}) => {
  const [reason, setReason] = useState(""); // State for the reason

  const dialogStyle = {
    minWidth: "600px", // Adjust the width as needed
    backgroundColor: "#e3f2fd", // Your desired background color
    border: "2px solid #ccc",
  };
  const titleStyle = {
    // backgroundColor: "#2196f3", // Title background color
    // color: "#fff", // Title text color
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        style: {
          ...dialogStyle,
          zIndex: 2000, // Ensure this is higher than other dialogs
        },
      }}
       slotProps={{
        backdrop: {
          invisible: true, // Makes the backdrop invisible
          style: { display: "none" }, // Optionally removes it entirely
        },
      }}
    >
      <HotkeysSuppressor>
        {/* Enter = primary action (Bestätigen / Ok), Escape = cancel (MUI default) */}
        <DialogDefaultAction
          onAction={onContinue ?? onClose}
          disabled={!open || !!loading}
        />
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <DialogTitle style={titleStyle} id="form-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {typeToProceed &&
            typeToProceed.length > 0 &&
            typeToProceed.map((type, index) => (
              <Button key={index} onClick={onClose} variant="contained" autoFocus={index === 0}>
                {type}
              </Button>
            ))}
          {!typeToProceed && (
            <>
              <Button onClick={onClose} variant="text">
                {isConfirmSave ? "Ohne Speichern schließen" : "Abbrechen"}
              </Button>
              {onContinue && (
                <Button onClick={onContinue} autoFocus>
                  {isConfirmSave ? "Speichern und schließen" : "Bestätigen"}
                </Button>
              )}
            </>
          )}
        </DialogActions>
      </HotkeysSuppressor>
    </Dialog>
  );
};

export default WarningDialog;
